/*
**  We need to add all of our components here due to the way the Redux ORM is set up. It expects these components (for reasons?).
**  Once we refactor Redux to not include the ORM and to be more modular, this shouldn't be a problem and we can both remove these and remove react.module entirely.
*/

import { react2angular } from 'react2angular'

import ExplorePage from './components_v1/pageLevelComponents/explore/ExplorePage'
import VideoPlayer from './components_v1/videoPlayer/VideoPlayer'
import VideoPreviewWrapper from './components_v1/admin/videos/VideoPreviewWrapper'
import PlanEntryListHeader from './components_v1/planEntry/PlanEntryListHeader'
import PlanEntryTile from './components_v1/planEntry/PlanEntryTile'
import AccessedItemsCarousel from './components_v1/accessedItems/AccessedItemsCarousel'
import AccessedItemsList from './components_v1/accessedItems/AccessedItemsList'
import PlaylistTile from './components_v1/playlist/PlaylistTile'
import UserPlaylists from './components_v1/playlist/UserPlaylists'

const app = angular.module('cody.react', [])

app.component(
  'explorePage',
  react2angular(ExplorePage, [
    'allProductCount',
    'baseUrl',
    'prefilteredSubcategories',
    'prefilteredCategories',
    'group',
    'defaultOrder',
    'categories',
    'difficulty',
    'intensity',
    'categoryFeaturedProducts',
    'featuredProducts',
    'pageVersion'
  ])
)
app.component(
  'planEntryListHeader',
  react2angular(PlanEntryListHeader, [
    'background',
    'coachName',
    'favoritable',
    'planSubscriptionId',
    'entryListOrigin',
    'title',
    'type'
  ])
)
app.component(
  'videoPlayer',
  react2angular(VideoPlayer, [
    'autoplay',
    'introVideo',
    'offerId',
    'origin',
    'originType',
    'poster',
    'planId',
    'planEntryId',
    'planSubscriptionId',
    'playlistPos',
    'resolution',
    'sourceId',
    'sourceType',
    'src',
    'title',
    'trackVideo',
    'type',
    'userLoggedIn',
    'noAutoplayOption',
    'video',
    'videoSession'
  ])
)

app.component(
  'videoPreviewWrapper',
  react2angular(VideoPreviewWrapper, ['label', 'video', 'durationInTitle'])
)

app.component(
  'planEntryTile',
  react2angular(PlanEntryTile, ['planEntry', 'hasDescription'])
)

app.component('accessedItemsList', react2angular(AccessedItemsList, ['items']))

app.component(
  'accessedItemsCarousel',
  react2angular(AccessedItemsCarousel, ['items'])
)

app.component(
  'playlistTile',
  react2angular(PlaylistTile, ['playlist', 'fromAngular'])
)

app.component(
  'userPlaylists',
  react2angular(UserPlaylists, ['uuid', 'playlistTab'])
)
